export const CalendarDays = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="22" height="22" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M5 11H27" stroke="currentColor" stroke-width="2"/>
<path d="M21 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M11 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M12 27V11" stroke="currentColor" stroke-width="2"/>
<path d="M20 27V11" stroke="currentColor" stroke-width="2"/>
<path d="M12 19H20" stroke="currentColor" stroke-width="2"/>
<rect x="20.5" y="11.5" width="6" height="8" fill="currentColor" stroke="currentColor"/>
<rect x="5.5" y="18.5" width="6" height="8" fill="currentColor" stroke="currentColor"/>
</svg>`;
